import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=6b8df712"
import script from "./OtpVerification.vue?vue&type=script&lang=js"
export * from "./OtpVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8df712')) {
      api.createRecord('6b8df712', component.options)
    } else {
      api.reload('6b8df712', component.options)
    }
    module.hot.accept("./OtpVerification.vue?vue&type=template&id=6b8df712", function () {
      api.rerender('6b8df712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/OtpVerification.vue"
export default component.exports